
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import LongPressComponent from '../../../../../components/longPress/LongPressComponent';
import SelectionView from '../../../../../components/selectionView/SelectionView'
import DiscountDialogue from '../../misc/DiscountDialogue'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var saleCalculator = require('../../../../../utils/domain/sales/saleCalculator');
var staffAccessUtility = require('../../../../../utils/domain/staff/staffAccessUtility');
var staffActivities = require('../../../../../utils/domain/staff/staffActivities');
var translator = require('../../../../../utils/translator/translator');
var saleContextUtil = require('../../../utils/saleContextUtil');
var constants = require('../../../../../utils/domain/constants');
var viewUtil = require('../../../../../utils/view/viewUtil');
var stringUtil = require('../../../../../utils/string/stringUtil');

class DiscountToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.renderComplimentDialogue = this.renderComplimentDialogue.bind(this);
        this.renderDiscountDialogue = this.renderDiscountDialogue.bind(this);

        this.state = {};
        this.state.selectedStaff = null;
        this.state.showComplimentDialogue = false;
        this.state.showDiscountDialogue = false;
    }

    render()
    {
        let saleContext = this.props.saleContext;
        
        let canAddDiscount = saleCommonUtility.canIssueDiscount(saleContext) &&
                             saleContext.selectedItems.length <= 1;
        return (<Fragment>
                    <LongPressComponent disabled={!canAddDiscount}
                        onClick={()=>
                        {
                            if (!canAddDiscount)
                                return; 

                            viewUtil.showLoginDialogue(staff =>
                            {
                                this.state.selectedStaff = staff;
                                this.onDiscount();
                            });

                        }}
                        onLongPress={()=>
                        {
                            if (!canAddDiscount)
                                return; 

                            viewUtil.showLoginDialogue(staff =>
                                {
                                    this.state.selectedStaff = staff;
                                    this.onCompliment();
                                });

                        }}>
                        <div style={{textAlign:'center', opacity:canAddDiscount ? 1 : 0.5, color: "#787878"}}>
                            <DiscountIcon size="2.2vw"/>
                        </div>
                    </LongPressComponent>
                    {this.renderComplimentDialogue()}
                    {this.renderDiscountDialogue()}
                </Fragment>)
    }

    onDiscount()
    {
        if (!staffAccessUtility.canStaffPerformActivity(this.state.selectedStaff, staffActivities.canApplyDiscount))
        {
            viewUtil.showErrorAlert(translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_discount"));
            return;
        }

        this.state.showDiscountDialogue = true;
        this.setState({});
    }

    onCompliment ()
    {
        let saleContext = this.props.saleContext;
        if (saleContext.selectedItems.length <= 0)
        {
            this.onDiscount();
            return;
        }

        let selectedItem = saleContext.selectedItems[0];
        if (selectedItem.isComplimented)
        {
            saleCommonUtility.revertItemAsCompliment(selectedItem);
            saleContextUtil.raiseSaleContextSaleChangeEvent(true);
            return;
        }

        if (!staffAccessUtility.canStaffPerformActivity(this.state.selectedStaff, staffActivities.canComplimentAnItem))
        {
            viewUtil.showErrorAlert(translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_compliment"));
            return;
        }
        
        this.state.showComplimentDialogue = true;
        this.setState({});
    }

    renderComplimentDialogue()
    {
        if (!this.state.showComplimentDialogue)
            return null;

        let selections = [];

        let selection = {};
        selection.caption = translator.getLabel("large_order");
        selection.id = translator.getLabel("large_order");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("loyal_customer");
        selection.id = translator.getLabel("loyal_customer");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("kitchen_error");
        selection.id = translator.getLabel("kitchen_error");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("celebration");
        selection.id = translator.getLabel("celebration");
        selections.push(selection);

        return <SelectionView selections={selections} caption={translator.getLabel("compliment_reasons")}
                                onClose={()=>
                                {
                                    this.state.showComplimentDialogue = false;
                                    this.setState({});
                                }}
                                onSelection={(selection)=>
                                {
                                    this.state.showComplimentDialogue = false;
                                    this.setState({});

                                    let saleContext = this.props.saleContext;
                                    let selectedItem = saleContext.selectedItems[0];
                                    saleCommonUtility.markItemAsCompliment(selectedItem, selection.id);
                                    saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                                }}/>
    }

    renderDiscountDialogue()
    {
        if (!this.state.showDiscountDialogue)
            return null;

        return <DiscountDialogue saleContext={this.props.saleContext} 
                                staff={this.state.selectedStaff}
                                onCancel={()=>
                                {
                                    this.state.showDiscountDialogue = false;
                                    this.setState({})
                                }}
                                onDiscount={discount =>
                                {
                                    this.state.showDiscountDialogue = false;
                                    this.setState({})

                                    this.applyDiscount(discount.code, discount.discountOfferType, discount.value, discount.minimumOrderAmount);
                                    saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                                }}
                                onVoucher={(voucher) =>
                                {
                                    this.state.showDiscountDialogue = false;
                                    this.setState({})
                                    this.props.onEnteringVoucher(voucher);
                                }}
                                onRemoveDiscount = {()=>
                                {
                                    this.state.showDiscountDialogue = false;
                                    this.setState({})
                                    
                                    this.removeAllDiscounts();
                                    saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                                }}/>
    }

    applyDiscount(discountCode, discountType, discountValue, discountMinOrder)
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        var discount = {};
        discount.selectedItemId = "";

        if (saleContext.selectedItems.length == 1)
        {
            let selectedItem = saleContext.selectedItems[0];
            this.removeSelectedItemLevelDiscounts();
            discount.saleItemId = selectedItem.id;
        }
        else
        {
            this.removeAllDiscounts();
        }

        discount.type = discountCode;
        discount.value = discountValue;
        discount.amount = null;
        discount.discountOfferType = discountType;
        discount.minimumOrderAmount = discountMinOrder;
        discount.notes = "";
        sale.discounts.push(discount);
    }

    removeAllDiscounts()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;
        sale.discounts = [];
    }

    removeSelectedItemLevelDiscounts()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;
        let selectedItem = saleContext.selectedItems[0];

        sale.discounts = sale.discounts.filter(d => !stringUtil.areStringSame(d.saleItemId, selectedItem.id));
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(DiscountToolbarButton)




const DiscountIcon = ({size}) =>
{
    return(
            <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z"></path>
            </svg>
    )
}